<template>
    <div class="practice-menu">
        <div class="practice-menu__content">
            <BackButton v-if="$screenWidth > 960" :link="lesson.link" :native="true" class="mb-20" />
            <flex-container v-else class="mb-20 pr-10" justify="space-between">
                <default-title>
                    {{ t("course.detail.practice") }}
                </default-title>
                <close-button-sm @click.native="closePracticeModal()" />
            </flex-container>
            <vue-simplebar class="practice-menu__scroll">
                <PracticeMenuItem
                    :lesson="lesson"
                    :quizzes="quizzes"
                    :quiz="quiz"
                    v-for="quiz in quizzes"
                    :key="quiz.id"
                />
            </vue-simplebar>
        </div>
    </div>
</template>

<script>
import PracticeMenuItem from "./PracticeMenuItem.vue"
import { VueSimplebar } from "vue-simplebar"
import BackButton from "@components/BackButton.vue"
import DefaultTitle from "@components/Typography/DefaultTitle.vue"
import FlexContainer from "@components/Containers/FlexContainer.vue"
import CloseButtonSm from "@components/Buttons/CloseButtonSm.vue"
import { EventBus } from "~events"

export default {
    props: {
        quizzes: {
            type: Array,
            default: () => []
        },
        lesson: {
            type: Object,
            default: null
        }
    },
    name: "PracticeMenu",
    components: { CloseButtonSm, FlexContainer, DefaultTitle, BackButton, PracticeMenuItem, VueSimplebar },
    created() {
        EventBus.$emit("practice:update-status", ({ id, status }) => {
            const quiz = this.quizzes.find(quiz => quiz.id === id)
            if (quiz) {
                quiz.status_id = status
            }
        })
    },
    methods: {
        closePracticeModal() {
            EventBus.$emit("practice:display", false)
        }
    }
}
</script>

<style scoped lang="sass">
.practice-menu
    width: 500px
    box-shadow: 0 4px 10px rgba(128, 158, 191, 0.15)
    border-radius: 10px 0 0 10px
    background: #FFFFFF
    top: 20px
    height: 100%
    transition: .3s
    overflow: hidden
    @media (max-width: 1300px)
        width: 400px
    @media (max-width: 960px)
        border-radius: 10px
        width: 100%
        box-shadow: 0 4px 10px rgba(128, 158, 191, 0.15)
    &__content
        padding: 20px 8px 20px 20px
        width: 500px
        height: 100%
        @media (max-width: 1300px)
            width: auto
        @media (max-width: 960px)
            width: 100%
    &__scroll
        height: calc(100% - 44px)
        &::v-deep
            .simplebar-vertical
                width: 4px !important
</style>
